// convertLevelInfoToIndexed.js
'use strict';

/**
 * data from API `/users/{id}` or `/me` response
 * @typedef {object} LevelInfo
 * @property {number} level - User VIP level
 * @property {(number | null)} nbf - not before timestamp, will be null if level is 0
 * @property {(number | null)} exp - expire timestamp, will be null if level is 0
 */

/**
 * convert level info to indexed object with level as key that getCurrentUserLevel can accept
 * @param {LevelInfo} levelInfo - param.
 * @returns {object} indexed object with level as key.
 */
const convertLevelInfoToIndexed = ({ levelInfo }) => {
  if (!levelInfo) return undefined;

  return {
    [levelInfo?.level || '0']: {
      nbf: levelInfo?.nbf || null,
      exp: levelInfo?.exp || null,
    },
  };
};

export default convertLevelInfoToIndexed;
